
// FIX: Corrected import path for models.
import { AppUser } from '../models/index';

// Add a timestamp for the required createdAt property
const now = new Date().toISOString();
const mockStoreId = 'mock-store-id-12345';

export const MOCK_USERS: AppUser[] = [
    // Real Admin (from original)
    { uid: 'admin01', storeId: mockStoreId, email: 'admin@greenleaf.com', name: 'Admin User', role: 'admin', status: 'active', createdAt: now },
    
    // Doctor
    { uid: 'doctor01', storeId: mockStoreId, email: 'doctor@clinic.com', name: 'นพ. สมชาย ใจดี (Dr. Somchai)', role: 'doctor', status: 'active', pin: '111111', createdAt: now },
    
    // Pharmacist / Cashier
    { uid: 'pharm01', storeId: mockStoreId, email: 'pharmacist@clinic.com', name: 'ภญ. วารี (Pharmacist)', role: 'cashier', status: 'active', pin: '222222', createdAt: now },
    
    // Staff
    { uid: 'staff01', storeId: mockStoreId, email: 'staff@clinic.com', name: 'สมศักดิ์ (Staff)', role: 'staff', status: 'active', pin: '333333', createdAt: now },
    
    // Accountant
    { uid: 'acct01', storeId: mockStoreId, email: 'accountant@clinic.com', name: 'คุณนิภา (Accountant)', role: 'accountant', status: 'active', pin: '444444', createdAt: now },
    
    // Owner
    { uid: 'owner01', storeId: mockStoreId, email: 'owner@clinic.com', name: 'คุณเจ้าของร้าน (Owner)', role: 'owner', status: 'active', pin: '888888', createdAt: now },

    // Legacy Mocks
    { uid: 'cashier01', storeId: mockStoreId, email: 'jessica@greenleaf.com', name: 'Jessica', role: 'cashier', status: 'active', pin: '123456', createdAt: now },
];
